import React from "react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { 
  Users, Building, Wrench, TrendingUp, 
  FileText, DollarSign, Handshake, Star 
} from "lucide-react";

const BenefitsSection = ({ data }) => {
  const iconMap = {
    "👥": <Users className="w-8 h-8 text-amber-600" />,
    "🏢": <Building className="w-8 h-8 text-amber-600" />,
    "🛠️": <Wrench className="w-8 h-8 text-amber-600" />,
    "📊": <TrendingUp className="w-8 h-8 text-amber-600" />,
    "📋": <FileText className="w-8 h-8 text-amber-600" />,
    "💰": <DollarSign className="w-8 h-8 text-amber-600" />,
    "🤝": <Handshake className="w-8 h-8 text-amber-600" />,
    "🌟": <Star className="w-8 h-8 text-amber-600" />
  };

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <Badge className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full mb-4">
            Program Benefits
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {data.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {data.subtitle}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {data.benefits.map((benefit, index) => (
            <Card key={index} className="group hover:shadow-xl hover:-translate-y-2 transition-all duration-300 border-2 hover:border-amber-200 bg-gradient-to-br from-white to-gray-50">
              <CardContent className="p-6">
                <div className="mb-4 group-hover:scale-110 transition-transform duration-300">
                  {iconMap[benefit.icon]}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-8 border border-amber-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Transform Your Startup Journey?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Join hundreds of entrepreneurs who have successfully built and scaled their startups through our comprehensive program.
            </p>
            <button 
              onClick={() => document.getElementById('apply').scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
            >
              Start Your Application
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;